import React from "react";
import {
  Avatar,
  Box,
  ButtonBase,
  Grid,
  Typography,
  useTheme
} from "@material-ui/core/index";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import paths from "../../../routes/paths";
import { prm } from "../../../mocks";

const operatorStates = ["Occupato", "Disponibile", "Attesa"];

export default function OperatorsListItem(props) {
  const passenger = prm[Math.floor(Math.random() * prm.length)];
  const operatorState =
    operatorStates[Math.floor(Math.random() * operatorStates.length)];
  const { operator, greyBackground } = props;
  const classes = styles();
  const history = useHistory();
  const theme = useTheme();

  const avatarColor = () => {
    switch (operatorState) {
      case "Occupato":
        return theme.palette.secondary.main;
      case "Disponibile":
        return theme.palette.primary.main;
      case "Attesa":
        return theme.palette.yellow.main;
    }
  };

  return (
    <ButtonBase
      className={classes.buttonContainer}
      onClick={() =>
        history.push({ pathname: paths.OPERATOR_DETAILS, state: { passenger } })
      }
    >
      <Grid
        className={classes.container}
        style={{
          backgroundColor: greyBackground
            ? theme.palette.grey.light
            : theme.palette.white
        }}
        container
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid
          container
          xs={2}
          direction={"column"}
          justify="center"
          alignItems="center"
        >
          <Avatar style={{ backgroundColor: avatarColor() }}>{""}</Avatar>
          <Typography className={classes.status}>{operatorState}</Typography>
        </Grid>
        <Grid
          container
          direction={"column"}
          xs={9}
          className={classes.centralContainer}
        >
          <Box
            borderBottom={2}
            borderTop={0}
            borderLeft={0}
            borderRight={0}
            className={classes.nameBox}
          >
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="center"
            >
              <Typography className={classes.passName}>{operator}</Typography>
              <Typography className={classes.opName}>
                Prm {passenger.name} {passenger.surname}
              </Typography>
            </Grid>
          </Box>
          <Grid container justify={"space-between"} direction={"row"}>
            <Grid>
              <Typography className={classes.infoTitle}>Volo</Typography>
              <Typography className={classes.info}>MUC/NAP</Typography>
            </Grid>
            <Grid>
              <Typography className={classes.infoTitle}>Codice</Typography>
              <Typography className={classes.info}>
                {passenger.ticketCode}
              </Typography>
            </Grid>
            <Grid>
              <Typography className={classes.infoTitle}>Gate</Typography>
              <Typography className={classes.info}>{passenger.gate}</Typography>
            </Grid>
            <Grid>
              <Typography className={classes.infoTitle}>STD</Typography>
              <Typography className={classes.info}>{passenger.time}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid xs={1} justify="flex-end" alignItems="center" container>
          <ChevronRightIcon className={classes.arrowIcon} />
        </Grid>
      </Grid>
    </ButtonBase>
  );
}

const styles = makeStyles(theme =>
  createStyles({
    buttonContainer: {
      width: "100%"
    },
    container: {
      padding: 8
    },
    avatar: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.black
    },
    status: {
      fontSize: 10,
      fontWeight: "700",
      color: theme.palette.grey.dark,
      marginTop: 5
    },
    centralContainer: {
      paddingLeft: 8
    },
    nameBox: {
      borderColor: theme.palette.divider,
      borderStyle: "dashed"
    },
    passName: {
      fontSize: 14,
      fontWeight: "600",
      color: theme.palette.black
    },
    opName: {
      fontSize: 14,
      fontWeight: "400",
      color: theme.palette.grey.dark
    },
    infoTitle: {
      fontSize: 12,
      fontWeight: "200",
      color: theme.palette.grey.dark
    },
    info: {
      fontSize: 12,
      fontWeight: "600",
      color: theme.palette.grey.dark
    },
    arrowIcon: {
      color: theme.palette.grey.dark
    }
  })
);
